<template>
  <v-row justify="center">
    <v-dialog
      v-model="isVisible"
      :fullscreen="$vuetify.breakpoint.xsOnly"
      max-width="450"
      persistent
      scrollable
    >
      <v-card>
        <v-toolbar
          flat
          height="80"
          max-height="80"
        >
          <v-avatar :class="$t('Pos.SelectCategoryDialog.Toolbar.Color')">
            <v-icon dark>
              {{ $t('Pos.SelectCategoryDialog.Toolbar.Icon') }}
            </v-icon>
          </v-avatar>

          <v-toolbar-title class="pl-3">
            <div class="body-3">
              {{ $t('Pos.SelectCategoryDialog.Toolbar.Title') }}
            </div>

            <div class="text-caption">
              {{ $t('Pos.SelectCategoryDialog.Toolbar.Subtitle') }}
            </div>
          </v-toolbar-title>

          <v-spacer />

          <v-btn
            icon
            @click="onCancelButtonClick"
          >
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider />

        <v-card-text
          ref="cardText"
          class="pa-0"
        >
          <v-container
            fluid
            pa-0
          >
            <v-row no-gutters>
              <v-col cols="12">
                <v-list
                  class="ma-0 pa-0"
                  dark
                  dense
                  one-line
                >
                  <template v-for="(item, index) in activeCategories">
                    <v-lazy
                      :key="`category-${item.Id}-${index}`"
                      :height="$vuetify.breakpoint.xsOnly ? '42' : '48'"
                      :max-height="$vuetify.breakpoint.xsOnly ? '42' : '48'"
                      :min-height="$vuetify.breakpoint.xsOnly ? '42' : '48'"
                      :options="{threshold: .25}"
                      transition="fade-transition"
                    >
                      <div>
                        <v-list-item
                          :class="[getCategoryColorClass(item)]"
                          :style="[getCategoryColorStyle(item), {height: $vuetify.breakpoint.xsOnly ? '40px' : '46px'}]"
                          ripple
                          @click="setCategory(item)"
                        >
                          <span
                            v-if="item.Color"
                            :style="`background-color: #${item.Color}; width: ${menuCategoriesColorWidthPos}px;`"
                            style="position: absolute; height: 100%; margin-left: -16px; padding: 0"
                          />

                          <v-list-item-content :class="[activeCategory && parseInt(activeCategory.Id) === parseInt(item.Id) ? 'grey--text text--darken-3' : 'grey--text text--darken-0']">
                            <v-list-item-title
                              :style="activeCategory && parseInt(activeCategory.Id) === parseInt(item.Id) ? `color: white !important;` : ''"
                              class="text-center"
                            >
                              {{ getTranslatedField(item, 'Name') }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>

                        <v-divider />
                      </div>
                    </v-lazy>
                  </template>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import AppData from '@/mixins/appdata'
import Translatable from '@/mixins/translatable'

export default {
  name: 'SelectCategoryDialog',

  components: {},

  mixins: [AppData, Translatable],

  props: {
    activeCategories: {
      type   : Array,
      default: undefined
    },

    activeCategory: {
      type   : Object,
      default: undefined
    },

    visible: {
      type   : Boolean,
      default: false
    }
  },

  DataStore: {posCart: 'cart'},

  data() {
    return {}
  },

  computed: {
    menuCategoriesColorWidthPos() {
      return this.appConfig?.LOCATION_DATA?.MenuCategoriesColorWidthPos ?? 5
    },

    isVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },

  watch: {},

  methods: {
    getCategoryColorClass(item) {
      if (parseInt(this.activeCategory?.Id) === parseInt(item.Id)) return ''

      return this.isDarkMode ? 'grey darken-4' : 'grey darken-3'
    },
    getCategoryColorStyle(item) {
      // `background-color: #${item.Color};` : ''
      if (parseInt(this.activeCategory?.Id) === parseInt(item.Id)) return `background-color: #${item.Color}`

      return ''
    },

    invertColor(hex, bw) {
      if (!hex) return '#FFFFFF'

      if (hex.indexOf('#') === 0) {
        hex = hex.slice(1)
      }
      // convert 3-digit hex to 6-digits.
      if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2]
      }
      if (hex.length !== 6) {

        console.warn('Invalid HEX color.')
        return '#FFFFFF'
      }
      let r = parseInt(hex.slice(0, 2), 16)
      let g = parseInt(hex.slice(2, 4), 16)
      let b = parseInt(hex.slice(4, 6), 16)
      if (bw) {
        // http://stackoverflow.com/a/3943023/112731
        return (r * 0.299 + g * 0.587 + b * 0.114) > 186
          ? '#323232'
          : '#FFFFFF'
      }
      // invert color components
      r = (255 - r).toString(16)
      g = (255 - g).toString(16)
      b = (255 - b).toString(16)
      // pad each with zeros and return
      return '#' + this.padZero(r) + this.padZero(g) + this.padZero(b)
    },

    padZero(str, len) {
      len = len || 2
      const zeros = new Array(len).join('0')
      return (zeros + str).slice(-len)
    },

    setCategory(category) {
      this.$emit('on-select-category', category)
      this.isVisible = false
    },

    onCancelButtonClick() {
      this.$refs.cardText.scrollTop = 0
      this.isVisible = false
    }
  }
}
</script>

<style scoped>
:deep(.v-list__tile--link) {
  padding: 0 !important;
}
</style>
